// extracted by mini-css-extract-plugin
export default {"header":"header_header__96Msz","clear":"header_clear__ulALK","logo":"header_logo__geMNw","app":"header_app__9umFy"};